import ShareModal from './LikeModal.container'

export default ShareModal
